import { fetchProposals } from 'common/api/v1/searchi';

import {
    FETCH_PROPOSALS,
    FETCH_PROPOSALS_FAILURE,
    FETCH_PROPOSALS_SUCCESS,
} from '../actionTypes';
import { actions } from '../reducer';

export default (q, page = 1, branchOfficeId = '') =>
    (dispatch) => {
        if (!q) return;

        dispatch(actions[FETCH_PROPOSALS]());

        fetchProposals({ q, page, branchOfficeId }).then(
            (response) => {
                dispatch(actions[FETCH_PROPOSALS_SUCCESS](response.data));
            },
            (error) => {
                dispatch(
                    actions[FETCH_PROPOSALS_FAILURE](error?.response?.data),
                );
            },
        );
    };
